<template>
    <form v-on:submit.prevent="saveForm" novalidate>
        <section :class="{ 'opacity-30': form.delete }">
            <section v-if="options">
                <label class="block text-sm font-medium text-gray-700 -mt-4">{{
                    t("form-mailing.role_id", "Ontvangers")
                }}</label>
                <div class="mt-1 relative rounded-md shadow-sm mb-6">
                    <select
                        v-model="form.role_id"
                        class="block w-full pl-3 pr-10 py-2 text-base focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                        :class="{
                            'disabled pointer-events-none bg-gray-100':
                                form.status != 'concept',
                        }"
                    >
                        <option value="">
                            {{ t("filter.role.all_members", "Alle leden") }}
                        </option>
                        <optgroup
                            :label="t('filter.' + optgroup)"
                            v-for="(options, optgroup) in options"
                            v-bind:key="optgroup"
                        >
                            <option
                                v-for="(option, value) in options"
                                v-bind:key="value"
                                :value="value"
                            >
                                {{ option }}
                            </option>
                        </optgroup>
                    </select>
                </div>
            </section>

            <label class="block text-sm font-medium text-gray-700 -mt-4">{{
                t("form-mailing.subject", "Onderwerp")
            }}</label>
            <div class="mt-1 relative rounded-md shadow-sm">
                <input
                    type="text"
                    class="block w-full pr-10 focus:outline-none sm:text-sm rounded-md"
                    :class="{
                        'border-red-300 text-red-900 focus:ring-red-500 focus:border-red-500':
                            getError('subject'),
                        'disabled pointer-events-none bg-gray-100':
                            form.status != 'concept',
                    }"
                    @keypress="errors = null"
                    v-model="form.subject"
                />
                <div
                    class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                >
                    <ExclamationCircleIcon
                        v-if="getError('subject')"
                        class="h-5 w-5 text-red-500"
                        aria-hidden="true"
                    />
                </div>
            </div>
            <p class="mt-2 text-xs text-red-600" v-if="getError('subject')">
                {{ getError("subject", true) }}
            </p>

            <section v-if="form.status != 'concept'">
                <label class="block text-sm font-medium text-gray-700 mt-2">{{
                    t("form-mailing.send_at", "Verstuurd op")
                }}</label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        class="block w-full pr-10 focus:outline-none sm:text-sm rounded-md disabled pointer-events-none bg-gray-100"
                        v-model="form.send_timestamp"
                    />
                </div>
            </section>

            <label
                class="block text-sm font-medium text-gray-700 mt-2 hidden"
                >{{ t("form-mailing.header", "Header") }}</label
            >
            <div class="mt-1 relative rounded-md shadow-sm hidden">
                <input
                    type="text"
                    class="block w-full pr-10 focus:outline-none sm:text-sm rounded-md"
                    :class="{
                        'border-red-300 text-red-900 focus:ring-red-500 focus:border-red-500':
                            getError('header'),
                    }"
                    @keypress="errors = null"
                    v-model="form.header"
                />
                <div
                    class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                >
                    <ExclamationCircleIcon
                        v-if="getError('header')"
                        class="h-5 w-5 text-red-500"
                        aria-hidden="true"
                    />
                </div>
            </div>
            <p
                class="mt-2 text-xs text-red-600 hidden"
                v-if="getError('header')"
            >
                {{ getError("header", true) }}
            </p>
        </section>

        <section :class="{ 'opacity-30': form.delete }">
            <!-- PHONE -->
            <label class="block text-sm font-medium text-gray-700 mt-2">{{
                t("form-mailing.content", "Content")
            }}</label>
            <div class="mt-1 relative rounded-md shadow-sm">
                <textarea
                    class="block w-full pr-10 focus:outline-none rounded-md font-mono text-xs hidden"
                    :rows="form.content && form.content.length > 50 ? 9 : 2"
                    :class="{
                        'border-red-300 text-red-900 focus:ring-red-500 focus:border-red-500':
                            getError('content'),
                    }"
                    @keypress="errors = null"
                    v-model="form.content"
                />
                <div
                    class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                >
                    <ExclamationCircleIcon
                        v-if="getError('content')"
                        class="h-5 w-5 text-red-500"
                        aria-hidden="true"
                    />
                </div>
            </div>
        </section>

        <article
            class="rounded-md"
            style="border: 1px solid #6b7280"
            :class="{
                'opacity-30': form.delete,
                'x-pointer-events-none': form.status != 'concept',
            }"
        >
            <section
                class="mail-body body"
                v-if="form"
                :style="'background-color:' + form.template_bg + '!important;'"
            >
                <table
                    class="wrapper"
                    width="100%"
                    cellpadding="0"
                    cellspacing="0"
                    role="presentation"
                    style="
                        box-sizing: border-box;
                        font-family: -apple-system, BlinkMacSystemFont,
                            'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
                            'Apple Color Emoji', 'Segoe UI Emoji',
                            'Segoe UI Symbol';
                        position: relative;
                        background: #d1e9f9 !important;
                        border-color: #d1e9f9 !important;
                        color: #333;
                        -premailer-cellpadding: 0;
                        -premailer-cellspacing: 0;
                        -premailer-width: 100%;
                        background-color: #edf2f7;
                        margin: 0;
                        padding: 0;
                        width: 100%;
                    "
                    :style="
                        'background-color:' +
                        form.template_bg +
                        '!important;  border-color:' +
                        form.template_bg +
                        '!important;'
                    "
                >
                    <tr>
                        <td
                            align="center"
                            style="
                                box-sizing: border-box;
                                font-family: -apple-system, BlinkMacSystemFont,
                                    'Segoe UI', Roboto, Helvetica, Arial,
                                    sans-serif, 'Apple Color Emoji',
                                    'Segoe UI Emoji', 'Segoe UI Symbol';
                                position: relative;
                            "
                        >
                            <table
                                class="content"
                                width="100%"
                                cellpadding="0"
                                cellspacing="0"
                                role="presentation"
                                style="
                                    box-sizing: border-box;
                                    font-family: -apple-system,
                                        BlinkMacSystemFont, 'Segoe UI', Roboto,
                                        Helvetica, Arial, sans-serif,
                                        'Apple Color Emoji', 'Segoe UI Emoji',
                                        'Segoe UI Symbol';
                                    position: relative;
                                    -premailer-cellpadding: 0;
                                    -premailer-cellspacing: 0;
                                    -premailer-width: 100%;
                                    margin: 0;
                                    padding: 0;
                                    width: 100%;
                                "
                            >
                                <tr>
                                    <td
                                        class="header"
                                        style="
                                            box-sizing: border-box;
                                            font-family: -apple-system,
                                                BlinkMacSystemFont, 'Segoe UI',
                                                Roboto, Helvetica, Arial,
                                                sans-serif, 'Apple Color Emoji',
                                                'Segoe UI Emoji',
                                                'Segoe UI Symbol';
                                            position: relative;
                                            padding: 25px 0;
                                            text-align: center;
                                        "
                                    >
                                        <input
                                            v-model="form.header"
                                            style="
                                                box-sizing: border-box;
                                                font-family: -apple-system,
                                                    BlinkMacSystemFont,
                                                    'Segoe UI', Roboto,
                                                    Helvetica, Arial, sans-serif,
                                                    'Apple Color Emoji',
                                                    'Segoe UI Emoji',
                                                    'Segoe UI Symbol';
                                                position: relative;
                                                color: #4f99d6 !important;
                                                font-size: 19px;
                                                font-weight: bold;
                                                text-decoration: none;
                                                display: inline-block;
                                                text-align: center;
                                                background: none;
                                                width: 100%;
                                                outline: none !important;
                                            "
                                            :style="
                                                'color: ' +
                                                form.template_text +
                                                '!important'
                                            "
                                            :class="{
                                                'pointer-events-none':
                                                    form.status != 'concept',
                                            }"
                                        />
                                    </td>
                                </tr>

                                <!-- Email Body -->
                                <tr>
                                    <td
                                        class="body"
                                        width="100%"
                                        cellpadding="0"
                                        cellspacing="0"
                                        style="
                                            box-sizing: border-box;
                                            font-family: -apple-system,
                                                BlinkMacSystemFont, 'Segoe UI',
                                                Roboto, Helvetica, Arial,
                                                sans-serif, 'Apple Color Emoji',
                                                'Segoe UI Emoji',
                                                'Segoe UI Symbol';
                                            position: relative;
                                            background: #d1e9f9;
                                            border-color: #d1e9f9;
                                            color: #333;
                                            -premailer-cellpadding: 0;
                                            -premailer-cellspacing: 0;
                                            -premailer-width: 100%;
                                            background-color: #edf2f7;

                                            margin: 0;
                                            padding: 0;
                                            width: 100%;
                                        "
                                        :style="
                                            'background-color:' +
                                            form.template_bg +
                                            '!important;  border-color:' +
                                            form.template_bg +
                                            '!important;'
                                        "
                                    >
                                        <table
                                            class="inner-body"
                                            align="center"
                                            width="570"
                                            cellpadding="0"
                                            cellspacing="0"
                                            role="presentation"
                                            style="
                                                box-sizing: border-box;
                                                font-family: -apple-system,
                                                    BlinkMacSystemFont,
                                                    'Segoe UI', Roboto,
                                                    Helvetica, Arial, sans-serif,
                                                    'Apple Color Emoji',
                                                    'Segoe UI Emoji',
                                                    'Segoe UI Symbol';
                                                position: relative;
                                                -premailer-cellpadding: 0;
                                                -premailer-cellspacing: 0;
                                                -premailer-width: 570px;
                                                background-color: #ffffff;
                                                border-color: #e8e5ef;
                                                border-radius: 2px;
                                                border-width: 1px;
                                                box-shadow: 0 2px 0
                                                        rgba(0, 0, 150, 0.025),
                                                    2px 4px 0
                                                        rgba(0, 0, 150, 0.015);
                                                margin: 0 auto;
                                                padding: 0;
                                                width: 570px;
                                            "
                                        >
                                            <!-- Body content -->
                                            <tr>
                                                <td
                                                    class="content-cell"
                                                    style="
                                                        box-sizing: border-box;
                                                        font-family: -apple-system,
                                                            BlinkMacSystemFont,
                                                            'Segoe UI', Roboto,
                                                            Helvetica, Arial,
                                                            sans-serif,
                                                            'Apple Color Emoji',
                                                            'Segoe UI Emoji',
                                                            'Segoe UI Symbol';
                                                        position: relative;
                                                        max-width: 100vw;
                                                        padding: 32px;
                                                        box-shadow: none !important;
                                                    "
                                                >
                                                    <editor
                                                        v-if="
                                                            form.status ==
                                                            'concept'
                                                        "
                                                        :template_text="
                                                            form.template_text
                                                        "
                                                        :template_bg="
                                                            form.template_bg
                                                        "
                                                        v-model="form.content"
                                                    />
                                                    <div
                                                        v-html="form.content"
                                                        v-if="
                                                            form.status !=
                                                            'concept'
                                                        "
                                                    ></div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>

                                <tr>
                                    <td
                                        style="
                                            box-sizing: border-box;
                                            font-family: -apple-system,
                                                BlinkMacSystemFont, 'Segoe UI',
                                                Roboto, Helvetica, Arial,
                                                sans-serif, 'Apple Color Emoji',
                                                'Segoe UI Emoji',
                                                'Segoe UI Symbol';
                                            position: relative;
                                        "
                                    >
                                        <table
                                            class="footer"
                                            align="center"
                                            width="570"
                                            cellpadding="0"
                                            cellspacing="0"
                                            role="presentation"
                                            style="
                                                box-sizing: border-box;
                                                font-family: -apple-system,
                                                    BlinkMacSystemFont,
                                                    'Segoe UI', Roboto,
                                                    Helvetica, Arial, sans-serif,
                                                    'Apple Color Emoji',
                                                    'Segoe UI Emoji',
                                                    'Segoe UI Symbol';
                                                position: relative;
                                                -premailer-cellpadding: 0;
                                                -premailer-cellspacing: 0;
                                                -premailer-width: 570px;
                                                margin: 0 auto;
                                                padding: 0;
                                                text-align: center;
                                                width: 570px;
                                            "
                                        >
                                            <tr>
                                                <td
                                                    class="content-cell"
                                                    align="center"
                                                    style="
                                                        box-sizing: border-box;
                                                        font-family: -apple-system,
                                                            BlinkMacSystemFont,
                                                            'Segoe UI', Roboto,
                                                            Helvetica, Arial,
                                                            sans-serif,
                                                            'Apple Color Emoji',
                                                            'Segoe UI Emoji',
                                                            'Segoe UI Symbol';
                                                        position: relative;
                                                        max-width: 100vw;
                                                        padding: 32px;
                                                    "
                                                >
                                                    <img
                                                        v-if="logo"
                                                        :src="logo"
                                                        alt=""
                                                        height="100"
                                                        style="
                                                            box-sizing: border-box;
                                                            font-family: -apple-system,
                                                                BlinkMacSystemFont,
                                                                'Segoe UI',
                                                                Roboto,
                                                                Helvetica, Arial,
                                                                sans-serif,
                                                                'Apple Color Emoji',
                                                                'Segoe UI Emoji',
                                                                'Segoe UI Symbol';
                                                            position: relative;
                                                            max-width: 100%;
                                                        "
                                                    />
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </section>
        </article>

        <section
            :class="{ 'opacity-30': form.delete }"
            v-if="form.id && form.status == 'concept'"
        >
            <div class="grid grid-cols-2 gap-4 mt-5">
                <div>
                    <label
                        class="block text-sm font-medium text-gray-700 -mt-2"
                        >{{
                            t("form-mailing.bg_color", "Achtergrondkleur")
                        }}</label
                    >
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                            type="color"
                            class="block w-full focus:outline-none sm:text-sm rounded-md h-8"
                            style="
                                border: 1px solid #6b7280;
                                outline: 0 !important;
                                padding: 0 !important;
                                outline-offset: 0 !important;
                            "
                            @keypress="errors = null"
                            v-model="form.template_bg"
                        />
                    </div>
                </div>
                <div>
                    <label
                        class="block text-sm font-medium text-gray-700 -mt-2"
                        >{{ t("form-mailing.text_color", "Tekstkleur") }}</label
                    >
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                            type="color"
                            class="block w-full focus:outline-none sm:text-sm rounded-md h-8"
                            @keypress="errors = null"
                            v-model="form.template_text"
                            style="
                                border: 1px solid #6b7280;
                                outline: 0 !important;
                                padding: 0 !important;
                                outline-offset: 0 !important;
                            "
                        />
                    </div>
                </div>
            </div>
        </section>

        <section
            :class="{ 'opacity-30': form.delete }"
            v-if="form.id && form.status == 'concept'"
        >
            <!-- PHONE -->
            <label
                class="block text-sm font-medium text-gray-700 mt-3"
                v-if="form.documents && form.documents.length > 0"
                >{{ t("form-mailing.attachments", "Bijlagen") }}</label
            >
            <label
                class="block text-sm font-medium text-gray-700 mt-1"
                v-if="form.documents && form.documents.length == 0"
                >&nbsp;</label
            >
            <div class="relative -mt-2">
                <div class="text-left">
                    <div
                        class="sm:col-span-2 py-5 pb-2"
                        v-if="form.documents && form.documents.length > 0"
                    >
                        <dd class="text-sm leading-5 text-gray-900">
                            <ul class="border border-gray-200 rounded-md">
                                <li
                                    class="pl-3 pr-4 py-3 flex items-center justify-between text-sm leading-5 bg-gray-50 hover:bg-white border-b border-color-gray-100"
                                    v-for="(
                                        document, subindex
                                    ) in form.documents"
                                    v-bind:key="subindex"
                                >
                                    <div class="w-0 flex-1 flex items-center">
                                        <svg
                                            class="flex-shrink-0 h-5 w-5 text-gray-400"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
                                                clip-rule="evenodd"
                                            />
                                        </svg>
                                        <span class="ml-2 flex-1 w-0 break-all">
                                            {{ document.name }}
                                            <span
                                                class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                                                >{{ document.extension }}</span
                                            >
                                        </span>
                                    </div>
                                    <div class="ml-4 flex-shrink-0">
                                        <a
                                            @click="deleteDocument(document)"
                                            class="cursor-pointer px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800 mr-2"
                                            >{{
                                                t("documents.delete", "wis")
                                            }}</a
                                        >
                                        <a
                                            :href="document.url"
                                            class="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                                        >
                                            {{ t("download", "Download") }}</a
                                        >
                                    </div>
                                </li>
                            </ul>
                        </dd>
                    </div>

                    <a
                        v-if="form.id && form.status == 'concept'"
                        class="inline-flex items-center px-4 cursor-pointer py-2 mt-1 border border-green-700 rounded-md shadow text-sm font-semibold text-green-50 bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                        @click="triggerFileUpload('bestand')"
                    >
                        <svg
                            class="fill-current w-4 h-4 mr-2"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
                                clip-rule="evenodd"
                            />
                        </svg>

                        {{ t("mailings.upload", "Upload bijlage") }}
                    </a>
                </div>
            </div>
        </section>

        <article>
            <SwitchGroup
                v-if="form.status == 'concept'"
                as="div"
                class="flex items-center mt-4"
                :class="{
                    'opacity-70 disabled pointer-events-none': form.send_mail,
                }"
            >
                <Switch
                    v-model="form.send_test"
                    class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    :class="{
                        'bg-blue-600': form.send_test,
                        'bg-gray-200': !form.send_test,
                        'opacity-70 disabled pointer-events-none':
                            form.send_mail,
                    }"
                >
                    <div
                        :class="{
                            'opacity-70 disabled pointer-events-none':
                                form.send_mail,
                        }"
                    >
                        <span
                            :class="[
                                form.send_test
                                    ? 'translate-x-5'
                                    : 'translate-x-0',
                                'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
                            ]"
                        >
                            <span
                                :class="[
                                    form.send_test
                                        ? 'opacity-0 ease-out duration-100'
                                        : 'opacity-100 ease-in duration-200',
                                    'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
                                ]"
                                aria-hidden="true"
                            >
                                <svg
                                    class="h-3 w-3 text-gray-400"
                                    fill="none"
                                    viewBox="0 0 12 12"
                                >
                                    <path
                                        d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </span>
                            <span
                                :class="[
                                    form.send_test
                                        ? 'opacity-100 ease-in duration-200'
                                        : 'opacity-0 ease-out duration-100',
                                    'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
                                ]"
                                aria-hidden="true"
                            >
                                <svg
                                    class="h-3 w-3 text-blue-600"
                                    fill="currentColor"
                                    viewBox="0 0 12 12"
                                >
                                    <path
                                        d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"
                                    />
                                </svg>
                            </span>
                        </span>
                    </div>
                </Switch>

                <SwitchLabel
                    as="span"
                    class="ml-3"
                    :class="{
                        'opacity-70 disabled pointer-events-none':
                            form.send_mail,
                    }"
                >
                    <span
                        class="text-sm font-medium text-gray-900"
                        :class="{
                            'opacity-70 disabled pointer-events-none':
                                form.send_mail,
                        }"
                        >{{
                            t("form-mail.send-test-mail", "Verstuur test-mail")
                        }}</span
                    >
                    <span class="text-xs text-blue-700 block">{{
                        t(
                            "form-mailing.send-test-info",
                            "U ontvangt zelf deze e-mail"
                        )
                    }}</span>
                </SwitchLabel>
            </SwitchGroup>

            <SwitchGroup
                v-if="form.id && form.status == 'concept'"
                as="div"
                class="flex items-center mt-4"
                :class="{
                    'opacity-70 disabled pointer-events-none': form.send_test,
                }"
            >
                <Switch
                    v-model="form.send_mail"
                    class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    :class="{
                        'bg-blue-600': form.send_mail,
                        'bg-gray-200': !form.send_mail,
                        'opacity-70 disabled pointer-events-none':
                            form.send_test,
                    }"
                >
                    <div
                        :class="{
                            'opacity-70 disabled pointer-events-none':
                                form.send_test,
                        }"
                    >
                        <span
                            :class="[
                                form.send_mail
                                    ? 'translate-x-5'
                                    : 'translate-x-0',
                                'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
                            ]"
                        >
                            <span
                                :class="[
                                    form.send_mail
                                        ? 'opacity-0 ease-out duration-100'
                                        : 'opacity-100 ease-in duration-200',
                                    'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
                                ]"
                                aria-hidden="true"
                            >
                                <svg
                                    class="h-3 w-3 text-gray-400"
                                    fill="none"
                                    viewBox="0 0 12 12"
                                >
                                    <path
                                        d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </span>
                            <span
                                :class="[
                                    form.send_mail
                                        ? 'opacity-100 ease-in duration-200'
                                        : 'opacity-0 ease-out duration-100',
                                    'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
                                ]"
                                aria-hidden="true"
                            >
                                <svg
                                    class="h-3 w-3 text-blue-600"
                                    fill="currentColor"
                                    viewBox="0 0 12 12"
                                >
                                    <path
                                        d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"
                                    />
                                </svg>
                            </span>
                        </span>
                    </div>
                </Switch>

                <SwitchLabel
                    as="span"
                    class="ml-3"
                    :class="{
                        'opacity-70 disabled pointer-events-none':
                            form.send_test,
                    }"
                >
                    <span
                        class="text-sm font-medium text-gray-900"
                        :class="{
                            'opacity-70 disabled pointer-events-none':
                                form.send_test,
                        }"
                        >{{ t("form-mail.send-mail", "Verstuur mail") }}</span
                    >
                    <span
                        class="text-xs text-blue-700 font-medium block"
                        v-if="form.send_mail"
                        >{{
                            t(
                                "form-mailing.send-mail-info",
                                "Alle deelnemers ontvangen deze e-mail"
                            )
                        }}</span
                    >
                    <!-- <span class="text-sm text-gray-500">(kan deelnemen met de webcam tijdens vergadering)</span> -->
                </SwitchLabel>
            </SwitchGroup>

            <SwitchGroup
                as="div"
                class="flex items-center mt-3"
                v-show="edit.id && edit.status == 'concept'"
                @click="checkDelete()"
            >
                <Switch
                    v-model="form.delete"
                    :class="[
                        form.delete ? 'bg-red-600' : 'bg-gray-200',
                        'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500',
                    ]"
                >
                    <span
                        :class="[
                            form.delete ? 'translate-x-5' : 'translate-x-0',
                            'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
                        ]"
                    >
                        <span
                            :class="[
                                form.delete
                                    ? 'opacity-0 ease-out duration-100'
                                    : 'opacity-100 ease-in duration-200',
                                'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
                            ]"
                            aria-hidden="true"
                        >
                            <svg
                                class="h-3 w-3 text-gray-400"
                                fill="none"
                                viewBox="0 0 12 12"
                            >
                                <path
                                    d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </span>
                        <span
                            :class="[
                                form.delete
                                    ? 'opacity-100 ease-in duration-200'
                                    : 'opacity-0 ease-out duration-100',
                                'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
                            ]"
                            aria-hidden="true"
                        >
                            <svg
                                class="h-3 w-3 text-red-600"
                                fill="currentColor"
                                viewBox="0 0 12 12"
                            >
                                <path
                                    d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"
                                />
                            </svg>
                        </span>
                    </span>
                </Switch>

                <SwitchLabel as="span" class="ml-3">
                    <span class="text-sm font-medium text-gray-900">{{
                        t("form-mailing.delete-mailing", "Verwijder mailing")
                    }}</span>
                    <span
                        class="text-xs text-red-700 block"
                        v-if="form.delete"
                        >{{
                            t(
                                "form-mailing.delete-confirm",
                                "Kan niet ongedaan gemaakt worden"
                            )
                        }}</span
                    >
                </SwitchLabel>
            </SwitchGroup>

            <input
                type="file"
                id="bestand"
                ref="bestand"
                v-on:change="addDocument('bestand')"
                style="display: none"
            />

            <div class="mt-3 sm:mt-6" v-if="form.status == 'concept'">
                <button
                    type="submit"
                    class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm disabled:opacity-50"
                    :class="{
                        'bg-red-600 text-red-50 hover:bg-red-700': form.delete,
                        'bg-blue-600 text-blue-50 hover:bg-blue-700':
                            !form.delete,
                    }"
                    :disabled="loading"
                >
                    <svg
                        v-if="loading"
                        class="animate-spin h-5 w-5 mr-4"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                        ></circle>
                        <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                    </svg>
                    {{ t("save", "Opslaan") }}
                </button>
            </div>
        </article>
    </form>
</template>

<script>
import { ExclamationCircleIcon, XIcon, TrashIcon } from "@heroicons/vue/solid";
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";
import Swal from "sweetalert2";
import Editor from "../../components/Editor.vue";

export default {
    components: {
        ExclamationCircleIcon,
        Switch,
        SwitchGroup,
        SwitchLabel,
        XIcon,
        TrashIcon,
        Editor,
    },
    mounted() {
        if (this.edit) {
            this.form = this.edit;
        }
        Eventing.fire("formMailing");

        Eventing.listen(
            "reloadAttachments",
            (attachments) => (this.form.documents = attachments)
        );
        this.setLogo();
    },
    created() {
        Eventing.fire("show-upload");
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.getFilterOptions();
    },
    props: ["edit"],
    data() {
        return {
            form: {
                email: null,
                name: null,
            },
            loading: false,
            errors: null,
            editor: null,
            logo: null,
            options: null,
        };
    },
    methods: {
        getFilterOptions() {
            axios
                .get("/api/modules/roles?options=role_id")
                .then((response) => {
                    this.options = response.data;
                })
                .catch((error) => {});
        },

        setLogo() {
            try {
                this.logo =
                    document.head.querySelector('meta[name="logo"]')?.content;
            } catch (error) {}
        },
        closeModal() {
            Eventing.fire("closeModal");
        },
        getError(error, text) {
            try {
                if (this.errors) {
                    let errors = Object.values(this.errors);
                    if (text) {
                        return this.errors[error].toString();
                    }
                    return this.errors[error].toString() ? true : false;
                }
            } catch (error) {
                return false;
            }
            return false;
        },
        saveForm() {
            let self = this;
            this.loading = true;
            var url = "/api/modules/newsletters";
            var method = "post";
            if (this.edit.hash && this.edit.hash != "undefined") {
                url = "/api/modules/newsletters/" + this.edit.hash;
                method = "put";
            }
            axios({
                method: method,
                url: url,
                data: this.form,
            })
                .then((response) => {
                    this.loading = false;
                    Eventing.fire("fetchMailings");
                    this.$router.push({ name: "mailings-index" });

                    if (self.form.send_mail) {
                        this.closeModal();
                        Eventing.fire("notify", {
                            title: self.t(
                                "mailing.mail-sending",
                                "Mail wordt gestuurd"
                            ),
                            message: self.t(
                                "mailing.mailing.mail-sending-text",
                                "Mailing wordt nu verstuurd naar alle ontvangers"
                            ),
                            type: "success",
                            position: "center",
                        });
                        setTimeout(() => {
                            Eventing.listen("fetchMailings");
                        }, 10000);
                        setTimeout(() => {
                            Eventing.listen("fetchMailings");
                        }, 20000);
                        this.$router.push({ name: "mailings-history" });
                    }
                    if (self.form.send_test) {
                        this.closeModal();
                        Eventing.fire("notify", {
                            title: self.t(
                                "mailing.mail-test-sending",
                                "Test mail wordt gestuurd"
                            ),
                            message: self.t(
                                "mailing.mailing.mail-test-text",
                                "U ontvangt in uw eigen mailbox nu een voorbeeld van de e-mail"
                            ),
                            type: "success",
                            position: "center",
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push("/login");
                    } else if (error.response.status == 422) {
                        this.errors = error.response.data.errors;
                        console.warn(error.response.data.errors);
                        // this.texts.content = errors["pincode"].toString();
                    } else if (error.response.status == 409) {
                        // this.texts.content = error.response.data.error;
                    } else {
                        this.closeModal();
                        // alert("Daar ging wat mis");
                    }
                    this.loading = false;
                });
        },
        checkDelete() {
            var val = this.form.delete;
            if (val == true) {
                Eventing.fire("warning");
            } else {
                Eventing.fire("noWarning");
            }
        },
        triggerFileUpload(field) {
            document.getElementById(field).click();
        },

        addDocument(field) {
            let self = this;
            this.file = this.$refs.bestand.files[0];
            let formData = new FormData();
            formData.append("bestand", this.file);
            var newsletter = this.form;
            formData.append("newsletter_id", newsletter.id);
            axios
                .post("/api/documenten", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(function (response) {
                    Eventing.fire("notify", {
                        title: self.t("mailing.upload-success", "Gelukt"),
                        message: self.t(
                            "mailing.attachment-added",
                            "Bijlage is toegevoegd"
                        ),
                        type: "success",
                    });
                    Eventing.fire("loadAttachments");
                })
                .catch(function (error) {
                    if (error.response) {
                        Eventing.fire("notify", {
                            title: self.t(
                                "mailing.attachment-failure",
                                "Mislukt"
                            ),
                            message: self.t(
                                "mailing.incorrect-form",
                                "Bijlage is te groot"
                            ),
                            type: "error",
                        });
                    }
                });
        },
        deleteDocument(document) {
            let self = this;
            Swal.fire({
                title: self.t(
                    "mailings.attachment-delete-title",
                    "Wis bijlage"
                ),
                text: self.t(
                    "mailings.attachment-delete-document",
                    "Zeker weten dat u de bijlage :value wilt verwijderen?",
                    document.name
                ),

                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#5850ec",
                cancelButtonColor: "#ddd",
                confirmButtonText: self.t("yes", "Annuleer"),
                cancelButtonText: self.t("cancel", "Annuleer"),
            }).then((result) => {
                if (result.value) {
                    if (true) {
                        axios
                            .delete("/api/documenten/" + document.hash)
                            .then((response) => {
                                Eventing.fire("notify", {
                                    title: self.t("succeeded", "Gelukt"),
                                    message: self.t(
                                        "mailings.attachment-deleted-success",
                                        "Bijlage verwijderd"
                                    ),
                                    type: "warning",
                                });
                                Eventing.fire("loadNewsletter");
                            })
                            .catch((error) => {
                                if (error.response) {
                                    alert("Error: " + error.response.status);
                                }
                            });
                    }
                }
            });
        },
    },
    watch: {},
};
</script>
<style scoped>
.wrapper,
.body {
    background: #d1e9f9;
    /* border-color: #d1e9f9; */
    color: #333;
}

.ProseMirror h1,
.ProseMirror h2,
.ProseMirror h3,
.ProseMirror,
.ProseMirror h5,
.ProseMirror a {
    color: #4f99d6 !important;
}

.mail-body {
    background: #d1e9f9;
    border: 1px solid #6b7280;
    border-radius: 0.375rem !important;
    border-color: #d1e9f9;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
        "Segoe UI Symbol";
    position: relative;
    -webkit-text-size-adjust: none;
    background-color: #ffffff;
    /* color: #718096; */
    height: 100%;
    line-height: 1.4;
    margin: 0;
    padding: 0;
    width: 100% !important;
}
</style>
